export const MAX_STORIES = 500;
export const STORY_INCREMENT = 30;
